module.exports = __webpack_public_path__ + "img/mast.66bfa73c.png";